export const LDJSON_FAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is your address?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Our company is located in sunny (and foggy) San Francisco.',
      },
    },
    {
      '@type': 'Question',
      name: 'Why is the parking so cheap?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "We negotiate the best possible deals in your airport parking market with the best parking providers. There are a couple circumstances to these great deals, and that is that we can't advertise the brand name with the highly negotiated price. This means we can only share the address of where you're parking after you purchase. We understand this isn't how you normally purchase parking, so we try very hard to get our customers to give feedback for you to learn from. You can find review on our Reviews Page, our Facebook Page, and our Google Page.",
      },
    },
    {
      '@type': 'Question',
      name: 'What are directions to your facility?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "You should receive an e-mail within 10 minutes of your purchase with the address and name of the parking facility at which you'll be parking. If it's hard to pull up the address on your GPS or maps, we suggest checking out our partner facilities’ website (by Googling their name), or by calling their number provided in your reservation.",
      },
    },
    {
      '@type': 'Question',
      name: 'How frequently do your shuttles run?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We are committed to providing our customers with the best shuttle service experience possible. To ensure this, we partner with parking facilities that prioritize shuttle frequency. To help you find the best parking facility for your needs, please look at individual listings to see shuttle frequency and distance to airport with our handy icons.',
      },
    },
    {
      '@type': 'Question',
      name: 'What is your cancellation policy?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "We appreciate you giving us a chance, and know this isn't how you're used to purchasing parking. That's why we offer free cancellations up to start date — no questions asked.",
      },
    },
    {
      '@type': 'Question',
      name: 'How do I cancel a reservation?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'We understand that things can happen. If you need to cancel a reservation simply respond to your e-mail confirmation reservation with the reservation number in it saying "I\'d like a refund" or something of the sort. We will then process your refund and send you a confirmation e-mail within 24-48 hours, or on the next business day if it\'s on a weekend.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I change a reservation?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Changing a reservation can be done in two ways. If you are extending your reservation by a day or two, simply settle the extra days at the parking facility upon your return. Don't worry, all of our parking partners are flexible with our clients and will never tow your vehicle. If you want to change your check-in date, or want to extend your parking for more than a couple days, we suggest you cancel out your reservation (see above), and re-purchase with the correct days.",
      },
    },
    {
      '@type': 'Question',
      name: 'Where do we find the shuttle when we return?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: "Each of our partners has different locations where they do their on-site airport pick-ups. We suggest you talk to the parking facility when you drop off your car. If you've already dropped your car off we suggest either going on to the parking facilities’ website (by Googling their name) or giving them a call. Their phone number and name are both in your confirmation e-mail.",
      },
    },
    {
      '@type': 'Question',
      name: "What's the best way to get a hold of someone?",
      acceptedAnswer: {
        '@type': 'Answer',
        text: "We'd love to chat! Since we receive a lot of calls, we suggest texting us at 424-532-8940. We typically respond within 1 hour. You can also call us at 888-48-PARKING (888-487-2754) or e-mail us at hello@noson.io! You can also check out our Contact Us Page.",
      },
    },
    {
      '@type': 'Question',
      name: 'What if something has happened and I need to extend my trip?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: `First off, you're ok. All cars are good to stay as long as possible — you just need to even up when you leave the parking facility. This is why we partner with professional parking companies that take care of you! To even up before you exit you'll either need to:
          1. Contact our support team at https://www.onairparking.com/contact and we'll let you know the protocols for your location.
          2. Pay the parking facility for the extra days that you stayed at their advertised daily rate.`,
      },
    },
  ],
};
